export const UPDATE_SELECT_PRINTER = 'UPDATE_SELECT_PRINTER'

export default {
  UPDATE_SELECT_PRINTER
}


// WEBPACK FOOTER //
// ./src/containers/PrinterSetup/store/actionTypes.js